const GeneralServerError = () => {
  return (
    <div style={{
      display: "flex", alignItems: "center", justifyContent: "center",
      minHeight: "100vh", background: "#f5f7fa",
      fontFamily: "system-ui, -apple-system, sans-serif",
    }}>
      <div style={{ textAlign: "center", padding: "40px 24px", maxWidth: "480px" }}>

        <div style={{
          fontSize: "7rem", fontWeight: 900, lineHeight: 1,
          color: "#e53935", marginBottom: "8px", letterSpacing: "-4px",
        }}>
          500
        </div>

        <div style={{
          width: "48px", height: "3px", borderRadius: "99px",
          background: "#e53935", margin: "0 auto 24px",
        }} />

        <div style={{ fontSize: "1.25rem", fontWeight: 700, color: "#212121", marginBottom: "10px" }}>
          Internal Server Error
        </div>
        <div style={{ fontSize: "0.9rem", color: "#9e9e9e", lineHeight: 1.7 }}>
          Something went wrong on our end. This has been noted and we're working on it.
          If the problem persists, please contact support.
        </div>

      </div>
    </div>
  );
};

export default GeneralServerError;
